import React from 'react';
import { styled, LazyImage } from '@teko/ui';
import cashIcon from '../../assets/images/cash.es.js';
import Voucher from '../../assets/images/voucher.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var PromoItemType = /* @__PURE__ */ ((PromoItemType2) => {
  PromoItemType2["GIFT"] = "gift";
  PromoItemType2["DISCOUNT"] = "discount";
  PromoItemType2["VOUCHER"] = "voucher";
  return PromoItemType2;
})(PromoItemType || {});
const Container = styled.div`
  display: flex;
  align-items: center;
`;
const StyledImg = styled(LazyImage)(({ hasBorder, theme }) => `
    height: 2.5rem;
    max-width: 2.5rem;
    min-width: 2.5rem;
    border-radius: 0.25rem;
    border: none;
    overflow: hidden;
    padding: 0;
    margin: 0;
    border: ${hasBorder ? `1px solid ${theme == null ? void 0 : theme.colors.border}` : "none"};
  `);
const Text = styled.p(({ theme }) => `
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: ${theme == null ? void 0 : theme.colors.text};
    font-size: 0.8125rem;
    line-height: 1.25rem;
    font-weight: 500;
    margin-left: 0.75rem;
  `);
const PromoItem = (_a) => {
  var _b = _a, {
    type,
    text,
    imgSrc
  } = _b, props = __objRest(_b, [
    "type",
    "text",
    "imgSrc"
  ]);
  const isGift = type === "gift" /* GIFT */;
  return /* @__PURE__ */ React.createElement(Container, __spreadValues({}, props), /* @__PURE__ */ React.createElement(StyledImg, {
    hasBorder: isGift,
    src: isGift && imgSrc ? imgSrc : type === "discount" /* DISCOUNT */ ? cashIcon : Voucher
  }), /* @__PURE__ */ React.createElement(Text, null, text));
};

export { PromoItem, PromoItemType };
